import { render, staticRenderFns } from "./DetailBlog4.vue?vue&type=template&id=9bd84eee&"
import script from "./DetailBlog4.vue?vue&type=script&lang=js&"
export * from "./DetailBlog4.vue?vue&type=script&lang=js&"
import style0 from "./DetailBlog4.vue?vue&type=style&index=0&id=9bd84eee&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bd84eee')) {
      api.createRecord('9bd84eee', component.options)
    } else {
      api.reload('9bd84eee', component.options)
    }
    module.hot.accept("./DetailBlog4.vue?vue&type=template&id=9bd84eee&", function () {
      api.rerender('9bd84eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailBlog4.vue"
export default component.exports